import Vue from 'vue';
import Router from 'vue-router';

import RouteView from '../components/route-view.vue';

import LoginN1pay from '../components/login/login-n1pay.vue';
import loginFastPay from '../components/login/login-fastpay.vue';
import LoginGopay from '../components/login/login-gopay';
import Login from '../components/login/login.vue';
import Home from '../components/home/home.vue';
import Orders from '../components/orders/orders.vue';
import Workplace from '../components/welcome';
import walletRecord from '../components/walletRecord/index.vue';
import merchantInfo from '../components/merchantInfo';
import withdrawBank from '../components/withdrawBank/index.vue';
import withdraw from '../components/withdraw/index.vue';
import merchantdeposit from '../components/merchantdeposit/index.vue';
import safeCenter from '@/components/safe-center';
import merchantBehalf from '../components/payout/orders';
import balanceHistory from '../components/balance-history';
import usdtAccount from '../components/usdt/account';
import usdtWithdrawList from '../components/usdt/withdrawlist';
import usdtOrderManage from '../components/usdt/index';
import usdtWithdrwa from '../components/usdt/withdrwa';
import subAccount from '../components/childrenlist/index.vue';
import Welcomes from '@/components/welcomes/index.vue';
import Clientmanage from '../components/clientmanage/index.vue';
import merchantdetails from '../components/clientmanage/merchantdetails.vue';

class MyRouter extends Router {
  push(location) {
    console.log('🚀 ~ file: index.js ~ line 27 ~ MyRouter ~ push ~ location', location);
    return super.push.call(this, location).catch((err) => err);
  }
}
Vue.use(MyRouter);

const asyncRouterMap = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/welcomes',
    children: [
      //没有权限时进入 welcomes页面
      {
        path: '/welcomes',
        name: 'welcomes',
        component: Welcomes,
        hidden: true,
        children: []
      },
      // welcome
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { permission: ['dashboard:manager'] },
        children: [
          {
            path: '/dashboard/workplace',
            name: 'Workplace',
            component: Workplace,
            meta: { permission: ['workplace:manager'] }
          }
        ]
      },
      // merchant
      {
        path: '/merchant',
        name: 'merchant',
        redirect: '/merchant/orders',
        component: RouteView,
        meta: { permission: ['merchant:manager'] },
        children: [
           {
            path: '/merchant/clientmanage',
            name: 'clientmanage',
            component: Clientmanage,
            meta: { permission: ['system:clientmanage'] }
          },
          {
            path: '/merchant/merchantdetails',
            name: 'merchantdetails',
            component: merchantdetails,
            meta: {
              isHide: true
            }
          },
          {
            path: '/merchant/orders',
            name: 'Orders',
            component: Orders,
            meta: { permission: ['merchant:order'] }
          },
          {
            path: '/merchant/merchantdeposit',
            name: 'merchantdeposit',
            component: merchantdeposit,
            meta: { permission: ['merchant:deposit'] }
          },

          {
            path: '/merchant/walletRecord',
            name: 'walletRecord',
            component: walletRecord,
            meta: { permission: ['system:walletRecord'] }
          },
          {
            path: '/merchant/payout/orders',
            name: 'merchantBehalf',
            component: merchantBehalf,
            meta: { permission: ['merchant:payout:orders'] }
          },
          {
            path: '/merchant/withdraw',
            name: 'merchantWithdraw',
            component: withdraw,
            meta: { permission: ['withdraw:manager'] }
          },
          {
            path: '/merchant/withdrawBank',
            name: 'withdrawBank',
            component: withdrawBank,
            meta: { permission: ['withdrawBank:manager'] }
          },
          {
            path: '/merchant/subAccount/list/page',
            name: 'subAccount',
            component: subAccount,
            meta: { permission: ['merchant:subAccount:list:page'] }
          },
          {
            path: '/merchant/merchantInfo',
            name: 'merchantInfo',
            component: merchantInfo,
            meta: {
              permission: ['merchantInfo']
              //  isKeepAlive: true
            }
          },
          {
            path: '/merchant/safeCenter',
            name: 'safeCenter',
            component: safeCenter,
            meta: { permission: ['securitycenter'] }
          },
          {
            path: '/merchant/balance/page',
            name: 'MerchantBalanceHis',
            component: balanceHistory,
            meta: { permission: ['merchant:balance:list'] }
          },

          {
            path: '/merchant/usdt/account/list/page',
            name: 'USDTAccount',
            component: usdtAccount,
            meta: { permission: ['merchant:usdt:account:list:page'] }
          },
          {
            path: '/merchant/usdt/withdraw/list',
            name: 'WithdrawList',
            component: usdtWithdrawList,
            meta: { permission: ['withdraw:usdt:list:page'] }
          },
          {
            path: '/merchant/usdt/list/page',
            name: 'USDTOrderManage',
            component: usdtOrderManage,
            meta: { permission: ['merchant:usdt:lis:page'] }
          },
          {
            path: '/merchant/usdt/withdraw',
            name: 'USDTWithdraw',
            component: usdtWithdrwa,
            meta: { permission: ['merchant:usdt:withdraw'] }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/welcomes',
    hidden: true
  }
];
const constantRouterMap = [
  {
    name: 'user',
    path: '/user',
    redirect: '/user/login',
    component: RouteView,
    children: [
      {
        name: 'login',
        path: '/user/login',
        component: getLoginComponent()
      }
    ]
  }
];

const router = new MyRouter({
  mode: 'history',
  routes: constantRouterMap
  // routes: asyncRouterMap
});

function getLoginComponent() {
  // 根据当前域名返回对应的登录页面组件
  const hostname = window.location.hostname;
  const hostAry = [
    [['n1', 'N1pay', 'n1pay', 'n1pay'], LoginN1pay, 'n1'],
    [['go'], LoginGopay, ''],
    [['fast'], loginFastPay, 'fast'],
    [['fastpay'], loginFastPay, 'fastpay'],
    [['fastPay'], loginFastPay, 'fastPay'],
    [['FastPay'], loginFastPay, 'FastPay']
  ];

  const host = hostAry.find((item) => {
    let _i = 0;
    const _keys = item[0];
    let _bol = false;
    if (_keys) {
      while (_i < _keys.length) {
        if (hostname.includes(_keys[_i])) {
          _bol = true;
        }
        _i++;
      }
    }
    return _bol;
  });
  if (host) {
    localStorage.setItem('login_info', host[2]);
    return host[1];
  } else {
    return Login;
  }
}
export { router as default, asyncRouterMap, constantRouterMap };



// WEBPACK FOOTER //
// ./src/router/index.js